export default "__VITE_ASSET__D2jJ8Tb5__"